export default __webpack_public_path__ + "794fb54daddece5d45293e6cbf2632c0.png";